/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function(){  

    $(".has_enable_slider").slick({
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 2000,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
      slidesToScroll: 1,
      touchThreshold: 50, 
      draggable: true,
      easing: 'ease-in'
    });
  
    $(".collection-list-custom .collection-list-wp").slick({
      dots: false,
      arrows: false,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 2000,
      speed: 1000,
      slidesToShow: 10,
      slidesToScroll: 2,
      touchThreshold: 100, 
      draggable: true,
      speed: 300,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 8
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 7
          }
        },
        {
          breakpoint: 880,
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

  $("body").on('afterChange','.has_enable_slider', function(event, slick, currentSlide, nextSlide){
    var prev = parseInt(currentSlide - 1);
    var next = parseInt(currentSlide + 1);
    $(this).find('.slick-dots li').hide();
    $(this).find('.slick-dots li:eq('+currentSlide+')').show();    
    
    if($(this).find('.slick-dots li:eq('+prev+')').length == 0){
      $(this).find('.slick-dots li:eq('+next+')').show();     
      next = next + 1;
      $(this).find('.slick-dots li:eq('+next+')').show();    
    }else{
      $(this).find('.slick-dots li:eq('+prev+')').show();     
    }    
    if($(this).find('.slick-dots li:eq('+next+')').length == 0){
      prev = prev - 1;
      $(this).find('.slick-dots li:eq('+prev+')').show();    
    }else{
      $(this).find('.slick-dots li:eq('+next+')').show();     
    }    
  });
  
  if($('.facet-grid-selector .grid-selector').length > 0){
    $('body').on('click','.facet-grid-selector .grid-selector', function(){
      var gridview = $(this).attr('data-view');
      $(this).closest('.facet-grid-selector').find('.grid-selector').removeClass('current');
      $(this).addClass('current');
      if(gridview == 1){
        $('body').attr('data-gridview','singleView');
      }else if(gridview == 2){
        $('body').attr('data-gridview','doubleView');
      }else{
        $('body').attr('data-gridview','fourView');
      }
      $('.product-list__inner .product-item .product-item__media_slider.has_enable_slider').slick('refresh');
    });
    var currentgridview = $('body').attr('data-gridview');
    if(currentgridview == 'singleView'){
      $('body .product-facet__meta-bar-item .grid-selector[data-view="1"]').addClass('current');
    }else if(currentgridview == 'doubleView'){
      $('body .product-facet__meta-bar-item .grid-selector[data-view="2"]').addClass('current');
    }else{
      $('body .product-facet__meta-bar-item .grid-selector[data-view="4"]').addClass('current');
    } 
  }  
  
  var call = 0;
  $('body').on('change','.has_size [data-selector-type="block"] .block-swatch__radio:eq(0)', function(){
    if(call == 0){
     call++; 
     var closest = $(this).closest('.has_size');    
      if(closest.find('[data-selector-type="block"] .block-swatch__radio:checked').closest('.block-swatch').hasClass('is-disabled') == false){    
       closest.find('[data-product-add-to-cart-button] .loader-button__text').html(closest.find("[data-product-add-to-cart-button]").attr("data-button-content")); 
      }      
      if($('.product-sticky-form').length > 0){
        $('.product-sticky-form').find('.combo-box__option-item[value="'+$(this).val()+'"]').trigger('click');      
      }
      closest.find('[data-product-add-to-cart-button]').removeAttr('disabled');      
      closest.find('.shopify-payment-button').show();
    }    
  });
  var ncall = 0;
  $('body').on('click','.hasstickysize.product-sticky-form .combo-box__option-item.mainOptions:eq(0)', function(){
    if(ncall == 0){
      ncall++;
      var closest = $(this).closest('.hasstickysize');        
      closest.find('[data-product-add-to-cart-button] .loader-button__text').html(closest.find("[data-product-add-to-cart-button]").attr("data-button-content")); 
      if($('.has_size .block-swatch__radio').length > 0){
        $('.has_size .block-swatch__radio[value="'+$(this).val()+'"]').trigger('click');
      }
      closest.find('[data-product-add-to-cart-button]').removeAttr('disabled');            
    }
  });
  
  $('body').on('click','.clickablebutton',function(){
    var mainwp = $(this).closest('.atc_button_wrp');    
    if(mainwp.find('[data-product-add-to-cart-button]').html().includes('size') == true){  
      if (window.matchMedia('(max-width: 740px)').matches){
        $('html, body').animate({
          'scrollTop': $('.product-form.has_size product-variants').offset().top - 100
        }, 900);
      }
      console.log('00',$('#AddToCart .loader-button__text').html().includes('size'));
      $('product-variants [data-selector-type="block"] .block-swatch-list').addClass('shake');
      setTimeout(function(){
        $('product-variants [data-selector-type="block"] .block-swatch-list').removeClass('shake');
      },1000)
    }
  });
  
});
